import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Course } from './courses.model';




@Injectable({
  providedIn: 'root'
})
export class CoursesService {

  constructor(private http: HttpClient) {
  }

  getCourses(): Observable<Course[]> {
    return this.http.get<Course[]>(
      `${environment.apiHost}/courses`,
    ) ;
  }

  getCourse(id: string): Observable<Course> {
    return this.http.get<Course>(
      `${environment.apiHost}/courses/${id}`,
    ) ;
  }

  createCourse(course:Course): Observable<Course> {
    return this.http.post<Course>(
      `${environment.apiHost}/courses`,
      course
    ) ;
  }

  updateCourse(course:Course): Observable<Course> {
    return this.http.post<Course>(
      `${environment.apiHost}/courses/${course.id}`,
      course
    ) as Observable<Course>;
  }

  getFullCourseName(course: Course) : string {

    if (course.year && course.session) {
      return `${course.name} (${course.session} ${course.year})` ;
    } else if (course.year) {
      return `${course.name} (${course.year})` ;
    } else if (course.session) {
      return `${course.name} (${course.session})` ;
    } else {
      return course.name ;
    }
  }


}
